import { createContext, useContext } from 'react';
import { createStore, type Store } from 'effector';
import { useUnit } from 'effector-react';
import type { TenantBranding } from '@buildex/module-contract';
import { DEFAULT_BRANDING } from './default-branding';

/**
 * Стор брендинга инжектится приложением (владелец стора — core).
 * Так theme и ui не зависят от core и матрица зависимостей не нарушается.
 */
export const BrandingStoreContext = createContext<Store<TenantBranding> | null>(null);

const $fallbackBranding = createStore<TenantBranding>(DEFAULT_BRANDING);

export function useBranding(): TenantBranding {
  const $branding = useContext(BrandingStoreContext);
  if ($branding === null && import.meta.env.DEV) {
    console.warn('useBranding: вне <TenantThemeProvider>, используется DEFAULT_BRANDING');
  }
  return useUnit($branding ?? $fallbackBranding);
}
